module.exports = __webpack_public_path__ + "static/media/LogicWedge2_5_drag_1.8a9ae0a3.png";